




































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import BrandApi from '@/api/goods/brand'

@Component({
  components: {}
})
export default class GoodsBrand extends AbpBase {
  columns: any[] = [
    {
      title: '品牌图',
      slot: 'picture',
      align: 'center'
    },
    {
      title: '品牌',
      key: 'name',
      align: 'center'
    },
    {
      title: '品牌首字母',
      key: 'brandInitial',
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []

  created() {
    this.getData()
  }

  /**
   * 获取所有品牌
   */
  getData() {
    BrandApi.getAll().then(res => {
      this.tableData = res.data.items
    })
  }

  /**
   * 删除品牌
   */
  deleteBrand(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    BrandApi.deleteById(id).then(res => {
      this.getData()
    })
  }
}
